

import {anchorLinkScroll, isInViewport, debounce} from './modules/helpers.js';

// Take some useful functions
import {
	closest_polyfill,
} from './modules/helpers.js';

// Tabs functionality (uncomment it if you need it)
import { tabsNavigation } from './modules/navi-tabs';



/**
 * All custom code is wrapped in IIFE function
 * to prevent affect our code to another parts of code
 */
;(function ( $ ) {
    
    
    document.addEventListener('wpcf7beforesubmit', function (event) {
        const formId = event.detail.contactFormId;
        const formEl = event.target;
        
        const data = new FormData(formEl);
        data.append( 'action', 'send_pulse' );
        data.append( 'form_id',  formId);
        
        fetch(var_from_php.ajax_url,
                {
                    method: "POST",
                    credentials: 'same-origin',
                    body: data
                })
                .then((response) => response.json())
                .then((responseData) => {
                    console.log('sendPulseSend', responseData);
                })
    });
    

	/**
	 * PLease Collect here all variables with DOM elements
	 * Use const for all DOM elements and type it as UPPERCASE text
	 * It will help to each developer understand that it's a const not a variable
	 */

	//const EXAMPLE = document.querySelector('.js-preloader-wrapper');
	const portfolioSlider = document.querySelector('.js-portfolio-slider');
	const infoIcon = document.querySelectorAll('.js-info-icon');
	const hamburger = document.querySelector('.js-hamburger');
	const closeMenu = document.querySelector('.js-close-menu');
	const scrollTop = document.querySelector('.js-scroll-top');
	const menuTop = document.querySelector('.js-mobile-menu');
	const closeSuccess = document.querySelectorAll('.js-close-success');
	const successMess = document.querySelector('.js-success-mess');
	const forms = document.querySelectorAll( '.wpcf7' );
	const orderPopupButton = document.querySelectorAll( '.js-open-order-popup' );
	const orderPopup = document.querySelector( '.js-order-popup' );
	const orderPopupClose = document.querySelector( '.js-close-order-popup' );
	const animateBlock = document.querySelectorAll( '.js-is-animate' );

	animateBlock && [...animateBlock].forEach( ( item ) => {
		if ( isInViewport( item, 10 ) ) {
			item.classList.add('animate');
		}
	} );

	/**
	 * Scroll handler
	 */
	window.addEventListener( 'scroll', ( event ) => {
		animateBlock && [...animateBlock].forEach( ( item ) => {
			if ( isInViewport( item, 100 ) ) {
				item.classList.add('animate');
			} else {
				item.classList.remove('animate');
			}
		} );

	} );

	anchorLinkScroll('.anchor a');

	orderPopupClose && orderPopupClose.addEventListener('click', event => {
		event.preventDefault();
		orderPopup && orderPopup.classList.remove('open');
	})

	orderPopupButton && orderPopupButton.forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			orderPopup && orderPopup.classList.add('open');
		})
	})

	scrollTop && scrollTop.addEventListener('click', event => {
		event.preventDefault();
		window.scroll( {
			'behavior': 'smooth',
			'left': 0,
			'top': 0
		} );
	})

	forms && forms.forEach(item => {
		item.addEventListener('wpcf7mailsent',event => {
			successMess && successMess.classList.add('open');
			orderPopup && orderPopup.classList.remove('open');
		})
	})

	closeSuccess && closeSuccess.forEach(elem => {
		elem.addEventListener('click', event => {
			event.preventDefault();
			successMess && successMess.classList.remove('open');
		})
	})

	menuTop && menuTop.addEventListener('click',event => {
		event.target.classList.remove('open');
	})

	closeMenu && closeMenu.addEventListener('click',event => {
		event.preventDefault();
		menuTop && menuTop.classList.remove('open');
	})

	hamburger && hamburger.addEventListener('click', (event) => {
		event.preventDefault();
		menuTop && menuTop.classList.add('open');
	})

	infoIcon && infoIcon.forEach((item) => {
		const itemHeight = item.clientHeight;
		const top = itemHeight/6;
		item.style.top = `-${top}px`;
	})

	if(portfolioSlider) {
		$('.js-portfolio-slider').slick({
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			centerMode: true,
			variableWidth: true,
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 3000,
            arrows: false,
		});
	}


	/**
	 * Occurs when all HTML has been fully loaded and passed by the parser,
	 * without waiting for the stylesheets, images and frames to finish loading
	 */
	document.addEventListener("DOMContentLoaded", function(event) {
		console.log("DOM fully loaded and parsed - READY event");

		// Init Closest polyfill method ( Don't delete it )
		closest_polyfill();

		// Init Popup Windows ( use it if you need Popup functionality )
		//const popup_instance = new Popup();
		//popup_instance.init();


		/**
		 * Add global handler for click event
		 * The main idea - to improve site performance
		 * We added only 1 event handler to "click" event
		 * and then use date-role attribute on each( needed ) elements
		 * to define on which element event was executed..
		 */
		document.body.addEventListener( 'click', event => {
			const ROLE = event.target.dataset.role;
			const clickElem = event.target;

			if ( !ROLE ) return;

			switch ( ROLE ) {

				// Scroll page to top
				case 'scroll-bottom':
				{
					event.preventDefault();
					const banner = clickElem.closest('.js-banner');
					if(!banner) return;
					const heightBanner = banner.clientHeight;
					window.scroll( {
						'behavior': 'smooth',
						'left': 0,
						'top': heightBanner
					} );

				}
					break;


				case 'element2':
				{
					// some required action
				}
					break;
			}
		} );

	});


	// Use it when you need to know that everything is loaded (html, styles, images)
	window.addEventListener('load', (event) => {


		/**
		 * Simple hack for some cases
		 */
		setTimeout( () => {
			document.body.classList.add( 'loaded' );
		}, 500 );


	});

})( jQuery );
